import React from 'react'
import { CustomMerchModule, CustomToutType } from '@/types'
import MerchModuleContentTypeWrapper from './MerchModuleContentTypeWrapper'
import ToutContentTypeWrapper from './ToutContentTypeWrapper'

function isToutType(
  promo: CustomMerchModule | CustomToutType
): promo is CustomToutType {
  return promo.contentTypeId === 'tout'
}

export default function MerchModuleWrapper({
  content,
  credCardModWrapDefaultDisplay = false,
  isUsingNewLayout = false
}: {
  content: CustomMerchModule | CustomToutType
  credCardModWrapDefaultDisplay?: boolean
  isUsingNewLayout?: boolean
}) {
  if (isToutType(content)) {
    return (
      <ToutContentTypeWrapper
        content={content}
        credCardModWrapDefaultDisplay={credCardModWrapDefaultDisplay}
        isUsingNewLayout={isUsingNewLayout}
      />
    )
  }
  return <MerchModuleContentTypeWrapper content={content} />
}
